"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridColumn = exports.Grid = exports.GridContext = void 0;
const react_1 = __importDefault(require("react"));
const Box_1 = require("../Box");
const GridColumnElement_1 = require("./GridColumnElement");
const GridElement_1 = require("./GridElement");
exports.GridContext = react_1.default.createContext({
    fillGapEnd: false,
    fillGapStart: false,
    initial: true,
    size: [null, null, null]
});
exports.Grid = react_1.default.forwardRef((_a, ref) => {
    var { children, initial, variant = "primary", wrap = true } = _a, props = __rest(_a, ["children", "initial", "variant", "wrap"]);
    const currentContext = react_1.default.useContext(exports.GridContext);
    const isInitial = initial !== undefined ? initial : currentContext.initial;
    const context = {
        fillGapEnd: false,
        fillGapStart: false,
        initial: isInitial,
        size: currentContext.size
    };
    return (react_1.default.createElement(GridElement_1.GridElement, Object.assign({ fillGapEnd: !!currentContext.fillGapEnd, fillGapStart: !!currentContext.fillGapStart, initial: context.initial, variant: variant, wrap: wrap, ref: ref }, props),
        react_1.default.createElement(exports.GridContext.Provider, { value: context }, children),
        wrap === false && isInitial && (react_1.default.createElement(Box_1.Box, { sx: {
                flexShrink: 0,
                width: [
                    "gridMobileColumnGutter",
                    "gridTabletColumnGutter",
                    "gridDesktopColumnGutter"
                ]
            } }))));
});
exports.Grid.displayName = "Grid";
const getGridArray = (size) => {
    if (Array.isArray(size)) {
        return size;
    }
    else {
        return [null, null, size !== undefined ? size : null];
    }
};
exports.GridColumn = react_1.default.forwardRef((_a, ref) => {
    var { children, fillEnd, fillGap, fillGapEnd, fillGapStart, fillStart, push: pushInitial, size: sizeInitial } = _a, props = __rest(_a, ["children", "fillEnd", "fillGap", "fillGapEnd", "fillGapStart", "fillStart", "push", "size"]);
    const { initial, size: contextSize } = react_1.default.useContext(exports.GridContext);
    const push = react_1.default.useMemo(() => getGridArray(pushInitial), [pushInitial]);
    const size = react_1.default.useMemo(() => getGridArray(sizeInitial), [sizeInitial]);
    const context = {
        fillGapEnd: !!fillGapEnd || fillGap || false,
        fillGapStart: fillGapStart || fillGap || false,
        initial: false,
        size: size || contextSize
    };
    return (react_1.default.createElement(GridColumnElement_1.GridColumnElement, Object.assign({ fillEnd: !!fillEnd, fillGapEnd: !!(fillGapEnd || fillGap), fillGapStart: !!(fillGapStart || fillGap), fillStart: !!fillStart, parentSize: !initial ? contextSize : [null, null, null], push: push, ref: ref, size: context.size }, props),
        react_1.default.createElement(exports.GridContext.Provider, { value: context }, children)));
});
exports.GridColumn.displayName = "GridColumn";
//# sourceMappingURL=Grid.js.map